import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap'

import { appendOnboarding } from '../../../../../features/session/sessionSlice'
import { appendModel } from '../../../../../features/site/siteSlice'
import { serviceMap } from '../../../../utils/common'

function SummaryCard({showEditButtons}){
    const dispatch = useDispatch()

    const model = useSelector(state => state.site.model)
    const state = useSelector(state => state.session.onboarding)

    const { siteForm } = model

    return <Card
        className="my-2"
        style={{
            maxWidth: "50em",
            border: "1px solid #ccc"
        }}>
        <CardHeader>
            Paid Ads Summary
        </CardHeader>
        <CardBody>
            
            <CardTitle tag="h4" className={`${showEditButtons ? "d-flex justify-content-between align-items-center" : ""}`}>
                <div>
                    <img src={serviceMap.bing.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.bing.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    bing: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 3,
                        paidAdsService: "bing"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small className="text-muted">Customer:</small> {state.dontHaveIt.bing ? "N/A" : siteForm?.attr?.accounts?.bing?.customerName}
            </h4>
            <h4>
                <small class="text-muted">Account:</small> {state.dontHaveIt.bing ? "N/A" : siteForm?.attr?.accounts?.bing?.accountName}
            </h4>
            <CardTitle tag="h4" className={showEditButtons ? "d-flex justify-content-between align-items-center mt-4" : " mt-4"}>
                <div>
                    <img src={serviceMap.fb.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.fb.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    fb: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 3,
                        paidAdsService: "fb"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small class="text-muted">Account:</small> {state.dontHaveIt.fb ? "N/A" : siteForm.attr?.accounts?.fb?.accountName}
            </h4>
            
            <CardTitle tag="h4" className={`${showEditButtons ? "d-flex justify-content-between align-items-center" : ""} mt-4`}>
                <div>
                    <img src={serviceMap.linkedin.img} class="mr-2 rounded img-thumbnail" style={{width:"40px"}} />
                    {serviceMap.linkedin.titleUnformatted}
                </div>
                {showEditButtons && <button className="ml-3 btn btn-outline-info btn-sm" onClick={() => {
                    dispatch(appendModel({
                        siteForm: {
                            ...siteForm,
                            attr: {
                                ...siteForm.attr,
                                accounts: {
                                    ...(siteForm?.attr?.accounts ?? {}),
                                    linkedin: undefined
                                }
                            }
                        }
                    }))
                    dispatch(appendOnboarding({
                        step: 3,
                        paidAdsService: "linkedin"
                    }))
                }}>Edit</button>}
            </CardTitle>
            <h4>
                <small class="text-muted">Account:</small> {state.dontHaveIt.linkedin ? "N/A" : siteForm?.attr?.accounts?.linkedin?.accountName}
            </h4>
        </CardBody>
    </Card>
}

SummaryCard.defaultProps = {
    showEditButtons: false
}

export default SummaryCard